import { useMemo } from 'react';
import { useLocale } from '../context/LocaleContext';
import { t as staticT } from '../locales';

export function useT() {
  const { locale } = useLocale();
  const code = locale?.code || 'en-US';
  return useMemo(() => (key) => staticT(code, key), [code]);
}

